import { render, staticRenderFns } from "./TabAlignment.vue?vue&type=template&id=d38e12ae"
import script from "./TabAlignment.vue?vue&type=script&lang=js"
export * from "./TabAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports